<template>
    <div class="all">
        <van-nav-bar
                title="申请提现"
                left-text="返回"
                right-text
                left-arrow
                @click-left="$goBack()"
                @click-right
                :border="false"
        />
            <div class="accounts">
          <van-tabs v-model="tabIndex"  color="#ee9900" :border="false" v-if="cashData.payeeInfoTplList.length>0">
            <van-tab :title="tpl.typeName"  v-for="(tpl,index) in cashData.payeeInfoTplList"  :key="index">
                  <div class="tabConent" v-if="cashData.cashBankInfoMap[tpl.type]&&cashData.cashBankInfoMap[tpl.type].bindSucc">
                  <van-cell :title="item.fieldName"
                            is-link
                            :to="'/user/detail/1?type='+tpl.type"
                            :value="cashData.cashBankInfoMap[tpl.type][item.field]"
                            v-for="(item,index) in tpl.fieldList"  :key="index"  />
                  </div>
                  <div v-else class="noID">
                     你还没有成功绑定此收款账户哦～，
                  <router-link :to="'/user/detail/1?type='+tpl.type">去绑定收款帐户</router-link>
                  </div>
            </van-tab>
          </van-tabs>
          <div class="noID" v-else>
              系统未配置收款账户,暂无法提现～
          </div>
          <div class="noID" v-if="cashData.needRealNameAuth">
              必须认证成功才能申请提现～
              <router-link to="/user/detail/3">去实名认证</router-link>
          </div>
          <div class="cash">
              <p>提现金额</p>
              <van-row style="border-bottom: 1px solid #f2f2f2;">
                  <van-col span="2">
                      <span>¥</span>
                  </van-col>
                  <van-col span="22">
                      <van-field v-model="cashForm.amountRMB" placeholder=""/>
                  </van-col>
              </van-row>
              <van-row>
                  <van-col span="12">可提现余额¥{{cashData.canCashBalanceRMB}}元,</van-col>
                  <van-col span="12">
                      <strong @click="cashAll()">全部提现</strong>
                  </van-col>
              </van-row>

              <van-button round @click="cashTrue()">确认提现</van-button>
          </div>
          <div class="bootom">
              <p>注意事项:</p>
              <p>
                  个体工商业者提现需按国家税法规定，我司已代缴个人所得税<br/>
                  首次提现需提供完整支付宝账号与收款人信息<br/>
                  支付宝账号，姓名，身份证（用于为该用户报税），以上信息必须一致<br/>
                  到账时间：提交申请后最迟1个工作日到账，单通常实时到账
              </p>
          </div>
      </div>

    </div>
</template>

<script>
    import fundAPI from '@/api/fund'

    export default {
        data() {
            return {
                cashData: {
                    needRealNameAuth:false,
                    canCashBalanceRMB: '',
                    cashBankInfoMap: null,
                    traderId:'',
                    payeeInfoTplList:[]
                },
                cashForm: {
                    amountRMB: '',
                    traderId: '',
                    cashAcctType: ''
                },
                tabIndex:0
            }
        },
        watch: {
        },
        created() {
            this.cashPre()
        },
        methods: {
            cashPre() {
                fundAPI.cashPre().then((result) => {
                    this.cashData = result.data
                    if(this.cashData.payeeInfoTplList.length>0){
                       this.tabIndex=0
                    }
                })
            },
            cashAll() {
                this.cashForm.amountRMB = this.cashData.canCashBalanceRMB
            },
            cashTrue() {
                if(!this.cashData.payeeInfoTplList[this.tabIndex]){
                    this.$toast.fail('账户类型必须选择')
                    return
                }
                this.cashForm.cashAcctType = this.cashData.payeeInfoTplList[this.tabIndex].type
                if (this.cashForm.amountRMB < 1) {
                    this.$toast.fail('提现金额过低')
                    return
                }
                fundAPI.cash(this.cashForm).then((result) => {
                    this.$toast.success('申请提现成功，等待审核！')
                    this.cashPre()
                })
            }
        },

    }
</script>

<style lang="scss" scoped>
    .all {
        background-color: #fff;
    }

    .accounts {
        margin-top: 0.2rem;
        img {
            margin-top: 1rem;
            height: 4rem;
            width: 4rem;
        }
    }

    .tabConent{
      margin: 1.5rem
    }

    .noID {
        margin: 1.5rem auto;
        padding: 1rem;
        text-align: center;
        font-size: 1.2rem;
        a {
            font-size: 1.2rem;
            text-decoration: underline;
            color: #ee9900;
        }
    }

    .cash {
        background-color: #fff;
        p {
            margin: 0rem 2rem;
            padding: 1rem 2rem;
            font-size: 1.2rem;
        }
        .van-row {
            margin: 0.5rem 2rem;
            padding: 0.5rem 2rem;
            font-size: 1.1rem;
            .van-col {
                span {
                    font-size: 2.5rem;

                }
                strong {
                    color: #ee9900;
                }
            }

        }
        .van-button {
            margin: 2rem 0rem;
            padding: 0rem 25%;
            left: 15%;
            background-color: #ee9900;
            color: #FFFFFF;
        }

    }

    .bootom {
        margin: 2rem 1rem;
        p {
            font-size: 1rem;
            color: #8b9196;
        }

    }

    .imgShow {
        margin: 20% auto;
        text-align: center;
        font-size: 1.2rem;
        a {
            text-decoration: underline;
            color: #ee9900;
        }
    }





</style>
